/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_Error_Title_Required1Inputs */

const vi_cmspage_error_title_required1 = /** @type {(inputs: Cmspage_Error_Title_Required1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập tiêu đề trang.`)
};

/**

* @param {Cmspage_Error_Title_Required1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_error_title_required1 = /** @type {((inputs?: Cmspage_Error_Title_Required1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Error_Title_Required1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_error_title_required1(inputs)
});
export { cmspage_error_title_required1 as "cmsPage_error_title_required" }